import { object, string } from 'yup';
import { isOutsideDateRange } from './helpers';
import { validationMessages } from './messages';

const isValidDate = (date) => date && !isOutsideDateRange(date);

export const customDateTimeSchema = object({
  date: string().required(validationMessages.dateRequired).test('is-valid-date', validationMessages.dateInvalid, isValidDate),
  time: string().required(validationMessages.timeRequired),
});
